import { Command } from 'commands/Commands';

export class ChangeHasBlog extends Command {
  priority: number = 100;
  type: string = 'ChangeHasBlog';
}
